import { decodeToHex, decrypt } from './crypto';
export const decryptEncodedEncryptedHolderPassphrase = (encryptedBytesBase64, privateKey)=>{
    const encryptedBytes = decodeToHex(encryptedBytesBase64);
    const holderPassphrase = decrypt(encryptedBytes, privateKey, 'RSAOAEP512');
    return holderPassphrase;
};
